<template>
  <div class="d-flex d-position-relative">
    <ImprovedProductImage :src="getImageUrl(`${product.sku}.jpg`, 256)" width="4em" class="p-2" square />
    <div class="info">
      <small>
        <MoreReadableSkuComponent :sku="product.sku" :is-temporary-sku="product.hasTemporarySku" />
      </small>
      <div>
        <span>{{ productName }}</span>
        <span class="flags-small ml-1" title="Landsexklusivitet">
          <img v-for="country of product.availableInCountries" :key="country" :src="getCountryFlag(country)" />
        </span>
      </div>
      <small>{{ getCategories1And2(product) }}</small>
    </div>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { SimplifiedProduct } from '@/models/Product'
import { getImageUrl, getMainName } from '@/utils/productUtils'
import { getCountryFlag } from '@/utils/tools'
import ImprovedProductImage from '@/components/products/ImprovedProductImage.vue'
import MoreReadableSkuComponent from './MoreReadableSkuComponent.vue'
import { computed } from 'vue'

const props = defineProps<{
  product: SimplifiedProduct
}>()

const productName = computed(() => props.product.name || getMainName(props.product))

const getCategories1And2 = (product: SimplifiedProduct) => {
  return product?.categories
    ?.slice(-2)
    .map((category) => category.name)
    .join(' > ')
}
</script>

<style lang="scss" scoped>
.info {
  white-space: normal;

  > * {
    display: block;
  }

  .language {
    margin-left: 0.5em;
    padding: 2px 4px;
    background-color: #eee;
    border: 1px solid grey;
  }
}
</style>
